// @ts-nocheck
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { storeGetOrder, StoreGetOrderApiParameter } from "@store/Framework/Services/StoreOrderService";

type HandlerType = ApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails" | "shipments/shipmentpackagelines")[] },
    StoreGetOrderApiParameter,
    OrderModel
>;

export const StorePopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        expand: ["orderLines", "shipments/shipmentpackagelines"],
    };
};

export const StoreRequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await storeGetOrder(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 404 || error.status === 403)) {
            props.dispatch({
                type: "Data/Orders/FailedToLoadOrder",
                orderNumber: props.parameter.orderNumber,
                status: error.status,
            });
            return false;
        }
        throw error;
    }
};

replaceInChain(chain, PopulateApiParameter, StorePopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, StoreRequestDataFromApi);

const loadOrderByOrderNumber = createHandlerChainRunner(chain, "LoadOrderByOrderNumber");
export default loadOrderByOrderNumber;
